import i18n from '@/i18n'

/**
 * Format a number as currency based on current locale.
 * Uses EUR currency with locale-appropriate formatting.
 */
export function formatCurrency(value: number | null): string {
  if (value === null) return '-'

  const lang = i18n.language.substring(0, 2) || 'de'
  const locale =
    lang === 'ar'
      ? 'ar-SA'
      : lang === 'es'
        ? 'es-ES'
        : lang === 'en'
          ? 'en-GB'
          : 'de-DE'

  return new Intl.NumberFormat(locale, {
    style: 'currency',
    currency: 'EUR',
  }).format(value)
}

/**
 * Format a number based on current locale.
 */
export function formatNumber(value: number): string {
  const lang = i18n.language.substring(0, 2) || 'de'
  const locale =
    lang === 'ar'
      ? 'ar-SA'
      : lang === 'es'
        ? 'es-ES'
        : lang === 'en'
          ? 'en-GB'
          : 'de-DE'

  return new Intl.NumberFormat(locale).format(value)
}
